import { Stack, Typography } from '@mui/material';
import { Company } from '../../graphql/types';
import AssetLogo from '../AssetLogo';
import React from 'react';

interface CompaniesWidgetProps {
  company: Company;
  useCompactViewStyle?: boolean;
  pt?: number;
  alignment?: 'flex-start' | 'center';
}

const CompaniesWidget = ({ company, useCompactViewStyle = false, alignment = 'center', pt = 0 }: CompaniesWidgetProps) => (
  <Stack direction={'row'} spacing={1.5} alignItems={alignment} height="100%" sx={{ pt }}>
    <AssetLogo logo={company.logo} name={company.legalName} size={useCompactViewStyle ? 'xs' : 'sm'} />
    <Typography
      sx={{
        fontSize: useCompactViewStyle ? 11 : 13,
        fontWeight: 400,
        pt: alignment === 'flex-start' ? (useCompactViewStyle ? 0.5 : 0.75) : 0
      }}
    >
      {company.legalName}
    </Typography>
  </Stack>
);

export default CompaniesWidget;
